import { z } from 'zod';
import { COMMUNITY_SORT as localStorageKey } from '../KEYS';
import type { SortBy, SortDir } from '@/modules/issuers-api';

type Stored = { sortBy: SortBy; sortDir: SortDir };

const defaultValue: Stored = { sortBy: 'stake', sortDir: 'desc' };

const StoredSchema: z.ZodType<Stored> = z.object({
  sortBy: z.enum(['stake', 'accuracy']),
  sortDir: z.enum(['asc', 'desc']),
});

export default {
  get(): Stored {
    const raw = localStorage.getItem(localStorageKey);
    // Stryker disable next-line ConditionalExpression: equivalent — a null row would go through JSON.parse as "null" and be rejected by the schema into the same default; this line is the fast path and the TS narrowing.
    if (raw === null) return defaultValue;
    try {
      return StoredSchema.parse(JSON.parse(raw));
    } catch {
      return defaultValue;
    }
  },

  set(value: Stored) {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  },
};
